module.exports = __webpack_public_path__ + "fonts/icomoon.ed2a3615.woff";